"use client";
import React, { useState, useEffect } from "react";
import Logo from "../images/logoo.png";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      const menu = document.querySelector(".mobile-menu");
      const toggleButton = document.querySelector(".menu-toggle-button");

      if (
        isOpen &&
        !menu?.contains(e.target) &&
        !toggleButton?.contains(e.target)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [isOpen]);

  return (
    <div 
      className="fixed w-full max-w-7xl top-3 z-50" 
      style={{
        padding: '12px 16px',
        left: '50%',
        transform: 'translateX(-50%)'
      }}
    >
      <div 
        className={`w-full max-w-7xl mx-auto flex items-center justify-between rounded-[50px] transition-all duration-300 ${
          scrolled 
            ? "bg-white/90 backdrop-blur-lg shadow-sm border border-gray-100" 
            : "bg-transparent"
        }`}
        style={{padding:'10px 10px'}}
      >
        <img 
          src={Logo} 
          alt="Vionex Labs Logo" 
          onClick={() => navigate('/')}
          className="w-[100px] md:w-[120px] h-auto cursor-pointer transition-opacity hover:opacity-80" 
          loading="lazy"
          style={{marginLeft:'20px', padding: '0 8px'}}
        />

        {/* Desktop Navigation */}
        <div className="hidden lg:flex items-center gap-8">
          {['Home', 'Services', 'Portfolio', 'Contact'].map((item) => (
            <a
              key={item}
              href={`/${item.toLowerCase()}`}
              className="text-gray-800 font-medium hover:text-[#182cd4] transition-colors duration-200"
            >
              {item}
            </a>
          ))}
        </div>

        {/* Desktop Button */}
        <a
          href="/contact"
          style={{padding:'10px 20px'}}
          className="hidden lg:flex h-11  items-center rounded-full bg-[#182cd4] text-white font-medium hover:opacity-90 transition-opacity duration-300 shadow-sm whitespace-nowrap"
        >
          Contact us
        </a>

        {/* Mobile Menu Button */}
        <button 
          onClick={() => setIsOpen(!isOpen)} 
          className="menu-toggle-button lg:hidden text-gray-700"
          style={{padding: '8px'}}
          aria-label={isOpen ? "Close menu" : "Open menu"}
        >
          <div className="w-6 h-6 relative">
            <span className={`absolute block h-0.5 w-6 bg-current rounded-full transition-all duration-300 ${isOpen ? 'rotate-45 top-[11px]' : 'top-[7px]'}`}></span>
            <span className={`absolute block h-0.5 w-6 bg-current rounded-full transition-all duration-300 ${isOpen ? 'opacity-0' : 'top-[11px]'}`}></span>
            <span className={`absolute block h-0.5 w-6 bg-current rounded-full transition-all duration-300 ${isOpen ? '-rotate-45 top-[11px]' : 'top-[15px]'}`}></span>
          </div>
        </button>
      </div>

      {/* Mobile Navigation Menu */}
      <div 
        className={`lg:hidden mobile-menu fixed top-[76px] inset-x-4 bg-white rounded-2xl shadow-xl transition-all duration-300 z-40 overflow-hidden ${
          isOpen 
            ? "opacity-100 translate-y-0" 
            : "opacity-0 translate-y-[-20px] pointer-events-none"
        }`}
      >
        <div className="flex flex-col" style={{padding: '16px 0'}}>
          {['Home', 'Services', 'Portfolio', 'Contact'].map((item) => (
            <a
              key={item}
              href={`/${item.toLowerCase()}`}
              className="text-gray-800 font-medium hover:bg-gray-50 transition-colors duration-200"
              style={{padding: '16px 24px'}}
              onClick={() => setIsOpen(false)}
            >
              {item}
            </a>
          ))}
          <button 
            className="h-12 rounded-xl bg-[#182cd4] text-white font-medium hover:opacity-90 transition-opacity duration-300 shadow-sm"
            style={{margin: '16px 24px'}}
            onClick={() => {
              navigate('/contact');
              setIsOpen(false);
            }}
          >
            Contact us
          </button>
        </div>
      </div>
    </div>
  );
};

export default Navbar;